import { environment } from '@env/environment';
import { URLSegment } from '../enums/global.enum';

export class APIConstants {
  static API_URL_BASE = environment.base_url + environment.api_version + environment.api_prefix;
  static API_URL_BASE_V2 = environment.base_url + environment.api_v2+ environment.api_prefix;
  static API_YCC_URL_BASE = environment.base_url + 'ycc/' + environment.api_version + environment.api_prefix;
  static API_REFRESH_TOKEN = APIConstants.API_URL_BASE + URLSegment.Auth + 'refresh-access-token';
  static API_LOGIN = APIConstants.API_URL_BASE + URLSegment.Auth + 'login';
  static API_CHANGE_PASSWORD = APIConstants.API_URL_BASE + URLSegment.Auth + 'change-password';
  static API_VERIFY_EMAIL = APIConstants.API_URL_BASE + URLSegment.Auth + 'verify-email';
  static API_REGISTER_DEVICE = APIConstants.API_URL_BASE + URLSegment.Auth + 'register-device';
  static API_RESET_PASSWORD = APIConstants.API_URL_BASE + URLSegment.Auth + 'reset-password';
  static API_GET_ALL_USERS = APIConstants.API_URL_BASE + URLSegment.User + 'users';
  static API_GET_ALL_COUNTRIES = APIConstants.API_URL_BASE + URLSegment.Shared + 'countries';
  static API_GET_ALL_INSURANCE_COMPANIES = APIConstants.API_URL_BASE + URLSegment.Shared + 'insurance-companies';
  static API_GET_ALL_INSURANCE_COVERS = APIConstants.API_URL_BASE + URLSegment.Shared + 'insurance-covers';
  static API_GET_ACTIVE_ROLES = APIConstants.API_URL_BASE + URLSegment.Role + 'active-roles';
  static API_GET_USER_BY_ID = APIConstants.API_URL_BASE + URLSegment.User;
  static API_ADD_USER = APIConstants.API_URL_BASE + URLSegment.User + 'add';
  static API_ADD_CUSTOMER = APIConstants.API_URL_BASE + URLSegment.Customer + 'add';
  static API_UPLOAD_MEDIA = APIConstants.API_URL_BASE_V2 + 'media';
  static API_GET_MEDIA_BY_ID = APIConstants.API_URL_BASE_V2 + 'media/';
  static API_UPDATE_USER = APIConstants.API_URL_BASE + URLSegment.User + 'update';
  static API_PUBLIC_SHIPMENT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'public-get-shipment-by-id';
  static API_PUBLIC_CUSTOMER_REGISTRATION = APIConstants.API_URL_BASE + URLSegment.Customer + 'register-customer';
  static API_PUBLIC_MADAR_CUSTOMER_REGISTRATION = APIConstants.API_URL_BASE + URLSegment.Customer + 'register-sme-customer';
  static API_PUBLIC_FLEET_REGISTRATION = APIConstants.API_URL_BASE + 'sign-up/fleet';
  static API_CUSTOM_RESET_PASSWORD = APIConstants.API_URL_BASE + URLSegment.Auth + 'custom-reset-password';
  static FORGET_PASSWORD = APIConstants.API_URL_BASE + URLSegment.Auth + 'forget-password';
  static FORGET_PASSWORD_VERIFY_MOBILE = APIConstants.API_URL_BASE + URLSegment.Auth + 'forget-password-verify-mobile';
  static VERIFY_MOBILE_NUMBER = APIConstants.API_URL_BASE + URLSegment.Auth + 'verify-mobile-number';
  static LOGIN_WITH_PHONE = APIConstants.API_URL_BASE + URLSegment.Auth + 'login-with-phone';
  static REQUEST_PHONE_LOGIN_OTP = APIConstants.API_URL_BASE + URLSegment.Auth + 'request-phone-login-otp';

  static REQUEST_OTP = APIConstants.API_URL_BASE + URLSegment.Auth + 'request-otp';
  static ADD_EDIT_PARAMS = APIConstants.API_URL_BASE + URLSegment.User + 'config/add-edit-params';
  static GET_USER_PARAMS = APIConstants.API_URL_BASE + URLSegment.User + 'config/params';
  static VERIFY_OTP = APIConstants.API_URL_BASE + URLSegment.Auth + 'verify-otp';

  // Notification
  static API_NOTIFICATIONS = APIConstants.API_URL_BASE + URLSegment.Shared + 'notifications';
  static API_UNREAD_NOTIFICATION_COUNT = APIConstants.API_URL_BASE + URLSegment.Shared + 'unread-notifications-count';
  static API_MARK_NOTIFICATIONS_AS_READ = APIConstants.API_URL_BASE + URLSegment.Shared + 'mark-notifications-as-read';
  static API_MARK_ALL_NOTIFICATIONS_AS_READ = APIConstants.API_URL_BASE + URLSegment.Notifications + 'mark-all-as-read';

  // Customers
  static API_GET_ALL_CUSTOMERS = APIConstants.API_URL_BASE + URLSegment.Customer + 'customers';
  static API_GET_ALL_CUSTOMERS_WITH_PAGINATION = APIConstants.API_URL_BASE + URLSegment.Customer + 'customers-with-pagination';
  static API_GET_CUSTOMER_BY_ID = APIConstants.API_URL_BASE + URLSegment.Customer;
  static API_UPDATE_CUSTOMER = APIConstants.API_URL_BASE + URLSegment.Customer + 'update';
  static API_GET_ALL_PRODUCT_TYPES = APIConstants.API_URL_BASE + URLSegment.ProductType + 'product-types';
  static API_ADD_PRODUCT_TYPES = APIConstants.API_URL_BASE + URLSegment.ProductType + 'add';
  static GET_PRODUCT_TYPE_ITEMS = APIConstants.API_URL_BASE + URLSegment.Shared + 'lookups/PRODUCT_ITEM';
  static UPDATE_PRODUCT_TYPES = APIConstants.API_URL_BASE + URLSegment.ProductType + 'update';
  static ADD_UPDATE_PRODUCT_TYPE = APIConstants.API_URL_BASE + URLSegment.ProductType + 'add';
  static API_GET_PRODUCT_BY_ID = APIConstants.API_URL_BASE + URLSegment.ProductType;
  static API_UPDATE_CUSTOMER_ETA = APIConstants.API_URL_BASE + URLSegment.Customer + 'update-customer-eta';
  static API_CUSTOMER_CUSTOM_DASHBOARD = APIConstants.API_URL_BASE + URLSegment.Customer + 'get-power-dashboard-token';
  static API_ADD_CUSTOMER_THEME = APIConstants.API_URL_BASE + URLSegment.WhiteLabel + 'add';
  static API_UPDATE_CUSTOMER_THEME = APIConstants.API_URL_BASE + URLSegment.WhiteLabel + 'update';
  static ADD_LOCATION_CUSTOMER = APIConstants.API_URL_BASE + URLSegment.Customer + 'add-location-customer';
  static GET_MY_CUSTOMERS = APIConstants.API_URL_BASE + URLSegment.Customer + 'my-customers';
  static UPDATE_R_CUSTOMERS = APIConstants.API_URL_BASE + URLSegment.Customer + 'update-R-customers';
  static CUSTOMER_LOCATIONS = APIConstants.API_URL_BASE + URLSegment.Customer + 'location';
  static GET_CREATION_TEMPLATE = APIConstants.API_URL_BASE + URLSegment.Customer + 'creation-template';

  static GET_WALLET_SUMMARY = APIConstants.API_URL_BASE + URLSegment.Wallet + 'wallets';
  static GET_WALLET_TRANSACTIONS = APIConstants.API_URL_BASE + URLSegment.Wallet + 'customer-transactions';
  static GET_VIRTUAL_IBAN = APIConstants.API_URL_BASE + URLSegment.Customer + 'viban';
  static GET_CUSTOMER_WALLET_TRANSACTIONS = APIConstants.API_URL_BASE + URLSegment.Wallet + 'customer-transactions';
  static GET_CUSTOMER_TRANSACTIONS = APIConstants.API_URL_BASE + URLSegment.WCC + 'transactions';

  static GET_CUSTOMER_OVERDUE_SUMMARY = APIConstants.API_URL_BASE + URLSegment.Customer + 'financial-summary/';

  static GET_CUSTOMER_DYNAMIC_FIELDS_CONFIG = APIConstants.API_URL_BASE + 'customer-dynamic-fields-config/' + URLSegment.Customer;

  // User preferences — ported from the admin portal. URLs must stay identical in both repos so
  // the two portals read each other's records.
  static GET_USER_PREFERENCES = APIConstants.API_URL_BASE + URLSegment.User + 'get_user_preferences';
  static UPDATE_USER_PREFERENCES = APIConstants.API_URL_BASE + URLSegment.User + 'update_user_preferences';

  // Bulk shipments
  static BULK_SHIPMENTS_DRAFT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/draft';
  static BULK_SHIPMENTS_DRAFT_SYNC = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/draft/sync';
  static BULK_SHIPMENTS_CREATE = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/create';
  static BULK_SHIPMENTS_ROUTE_DEFAULTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/route-defaults';
  static BULK_SHIPMENTS_LOCATIONS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/locations';
  static BULK_SHIPMENTS_COLUMNS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/columns';
  /** The customer's saved column mapping for sheet imports. It is configured from the admin portal. */
  static BULK_IMPORT_MAPPING = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/import/mapping';
  /** Reads an uploaded sheet against that mapping and reports what it found. Creates nothing. */
  static BULK_IMPORT_VALIDATE = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/import/validate';
  /** Creates the shipments for the valid rows of an already-validated batch. */
  static BULK_IMPORT_CONFIRM = APIConstants.API_URL_BASE + URLSegment.Shipment + 'bulk/import/confirm';

  // Payment
  static API_INIT_PAYMENT = APIConstants.API_URL_BASE + URLSegment.Payment + 'init-payment';
  static API_CHECK_TRANSACTION = APIConstants.API_URL_BASE + URLSegment.Payment + 'check-transaction';
  static CREATE_VIRTUAL_IBAN = APIConstants.API_URL_BASE + URLSegment.Payment + 'viban';

  static GET_WCC_LOGS = APIConstants.API_URL_BASE + URLSegment.Order + URLSegment.Logs;
  static RETRY_WCC_LOG = APIConstants.API_URL_BASE + URLSegment.Order + 'retry-orders';

  //organization
  static API_GET_ORGANIZATION_BY_ID = APIConstants.API_URL_BASE + URLSegment.Organization;

  //order
  static API_ORDERS_UPLOADED = APIConstants.API_URL_BASE + URLSegment.Order + 'upload-order-items';
  static CREATE_SHIPMENT_ORDER = APIConstants.API_URL_BASE + URLSegment.Shipment + 'add/list';
  static CREATE_SHIPMENT_BETA = APIConstants.API_URL_BASE + URLSegment.Shipment + 'add/beta';
  static SHIPMENT_ROUTING = APIConstants.API_URL_BASE + URLSegment.ShipmentRouting;
  static SHIPMENT_ROUTING_INFO = APIConstants.API_URL_BASE + URLSegment.ShipmentRouting + 'routing-info';
  static GET_ORDERS_CUSTOMERS = APIConstants.API_URL_BASE + URLSegment.Order + 'orders-customers/';
  static API_UPDATE_ORDERS_PRIORITY = APIConstants.API_URL_BASE + URLSegment.Order + 'update-orders-priority';

  // Receivers
  static API_GET_ALL_RECEIVERS = APIConstants.API_URL_BASE + URLSegment.Receiver + 'receivers';
  static API_ADD_RECEIVER = APIConstants.API_URL_BASE + URLSegment.Receiver + 'add';
  static API_GET_RECEIVER_BY_ID = APIConstants.API_URL_BASE + URLSegment.Receiver;
  static API_UPDATE_RECEIVER = APIConstants.API_URL_BASE + URLSegment.Receiver + 'update';
  static API_EXPORT_RECEIVERS = APIConstants.API_URL_BASE + URLSegment.Receiver + 'export-receivers-excel';

  // Location
  static API_ADD_LOCATION = APIConstants.API_URL_BASE + URLSegment.Shared + 'location/add';
  static API_EDIT_LOCATION = APIConstants.API_URL_BASE + URLSegment.Shared + 'location/update';
  static API_LOCATION_GET_ALL = APIConstants.API_URL_BASE + URLSegment.Shared + 'active-locations';
  static GET_LOCATION_DETAILS = APIConstants.API_URL_BASE + URLSegment.Shared + 'location';
  static API_GET_WCC_REGIONS = APIConstants.API_URL_BASE + URLSegment.WCC + 'regions';
  static API_GET_WCC_RECEIVERS = APIConstants.API_URL_BASE + URLSegment.WCC + 'receivers';

  // Fleet Provider
  static API_GET_ALL_FLEETS = APIConstants.API_URL_BASE + URLSegment.Fleet + 'fleets';
  static API_ADD_FLEET = APIConstants.API_URL_BASE + URLSegment.Fleet + 'add';
  static API_GET_FLEET_BY_ID = APIConstants.API_URL_BASE + 'fleet';
  static API_UPDATE_FLEET = APIConstants.API_URL_BASE + URLSegment.Fleet + 'update';
  static API_GET_ACTIVE_FLEETS = APIConstants.API_URL_BASE + URLSegment.Fleet + 'active-fleets';
  static API_VERIFY_FLEET = APIConstants.API_URL_BASE + URLSegment.Fleet + 'verify';
  static API_VALID_FLEETS_TO_MOVE = APIConstants.API_URL_BASE + URLSegment.Fleet + 'valid-fleets-to-transfer';
  static API_GET_SPECIFIC_FLEET = APIConstants.API_URL_BASE + URLSegment.Fleet + 'specific-fleets';
  static GET_CLASSIFIED_TRADELANES = APIConstants.API_URL_BASE + 'truck-area-preference';
  static API_GET_ALL_FLEETS_COUNT = APIConstants.API_URL_BASE + URLSegment.Fleet + 'fleets-count';

  // Shipments
  static API_GET_SHIPMENT_BY_ID = APIConstants.API_URL_BASE + URLSegment.Shipment;
  static GET_SHIPMENT_SUMMARY_BY_ID = (id: string | number) => APIConstants.API_URL_BASE + URLSegment.Shipment + id + '/summary';
  static GET_SHIPMENT_TRACKING_BY_ID = (id: string | number) => APIConstants.API_URL_BASE + URLSegment.Shipment + id + '/tracking';
  static GET_SHIPMENT_REQUESTS_BY_ID = (id: string | number) => APIConstants.API_URL_BASE + URLSegment.Shipment + id + '/requests';
  static GET_SHIPMENT_FINANCIAL_BY_ID = (id: string | number) => APIConstants.API_URL_BASE + URLSegment.Shipment + id + '/financial';

  static GET_DELIVERY_NOTE = APIConstants.API_URL_BASE + URLSegment.DeliveryNote;

  static API_ASSIGN_FLEET = APIConstants.API_URL_BASE + URLSegment.Shipment + 'assign';
  static API_GET_ALL_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'shipments';
  static API_SHIPMENT_ADD = APIConstants.API_URL_BASE + URLSegment.Shipment + 'add/beta';

  static API_SHIPMENT_UPDATE = APIConstants.API_URL_BASE + URLSegment.Shipment + 'update';
  static API_SHIPMENT_UPDATE_STATUS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'update/' + 'status';
  static API_GET_SPOT_PRICES_RATE = APIConstants.API_URL_BASE + URLSegment.Contract + 'spot-price';
  static API_GET_USER_PERFORMANCE = APIConstants.API_URL_BASE + URLSegment.Shipment + 'user-performance';
  static API_GET_SHIPMENT_PATH = environment.socket_url + environment.api_version + environment.api_prefix + URLSegment.ShipmentLocation;
  static GET_SHIPMENT_AVL_PATH = APIConstants.API_URL_BASE + URLSegment.Traccar + 'shipments/';
  static API_DOWNLOAD_EWAYBILL = APIConstants.API_URL_BASE + URLSegment.Shipment + 'preview-shipment-ewaybill';
  static API_EXPORT_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'export-shipments-list-csv';
  static API_UPDATE_SHIPMENT_DELIVERY_NOTES = APIConstants.API_URL_BASE + URLSegment.Shipment + 'update-delivery-notes';
  static API_FLEET_ACCEPT_SHIPMENT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'fleet-accept-shipment';
  static API_DELETE_SHIPMENT = APIConstants.API_URL_BASE + URLSegment.Shipment;
  static GET_SHIPMENT_REQUESTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'requests/';
  static PRINT_BAYAN_TRIP = APIConstants.API_URL_BASE + URLSegment.Shipment + 'print-bayan-trip';
  static BAYAN_INTEGRATE_TRIP = APIConstants.API_URL_BASE + URLSegment.Shipment + 'create-bayan-trip';
  static GET_RUNNING_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'running-shipments/';
  static GET_SHIPMENT_INFO_COUNTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'shipment-info-counts';
  static GET_SHIPMENT_DOOR_OPEN_HISTORY = APIConstants.API_URL_BASE + URLSegment.Shipment + 'door-open-history';
  static GET_SHIPMENT_ORDER_ROUTE = APIConstants.API_URL_BASE + 'shipment-orders-route';
  static GET_ALL_SHIPMENTS_COUNT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'shipments-count';

  static GET_SHIPMENT_INTEGRATIONS = APIConstants.API_URL_BASE + URLSegment.Integration + 'shipments';
  static INTEGRATE_SHIPMENT = APIConstants.API_URL_BASE + URLSegment.Integration + 'integrate';
  static GET_LIVE_TRACKING_SHIPMENTS_LIST = APIConstants.API_URL_BASE + URLSegment.Shipment + 'live-tracking-shipments';
  static GET_AVL_EXTERNAL_DEVICE_SUMMARY = APIConstants.API_URL_BASE + URLSegment.ExternalTracking + 'device-summary/' + 'AFAQY';
  static GET_DALEEL_TRACKING = APIConstants.API_URL_BASE + URLSegment.DaleelTracking;
  static GET_DALEEL_RUNNING_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.DaleelTracking + 'get-all-daleel-positions';
  static GET_SHIPMENT_MOBILE_TRACKING_ACTIVITY_LOGS = APIConstants.API_URL_BASE + URLSegment.Traccar + 'activity-logs/';

  static GET_DYNAMIC_FIELDS_VALUES = APIConstants.API_URL_BASE + URLSegment.Shipment + 'dynamic-fields';
  static GET_SHIPMENT_BIDS = APIConstants.API_URL_BASE + URLSegment.FleetBid + URLSegment.Shipment;
  static ACCEPT_SHIPMENT_BID = (bidId: number) => APIConstants.API_URL_BASE + URLSegment.FleetBid + bidId + '/accept';
  static CLOSE_BIDDING_SHIPMENT = APIConstants.API_URL_BASE + URLSegment.Shipment + URLSegment.Bidding + 'close/';

  // Requests
  static UPDATE_TRAILER_LABEL = APIConstants.API_URL_BASE + URLSegment.Request + 'update/trailer-label';
  static MARK_SHIPMENT_DELIVERED = APIConstants.API_URL_BASE + URLSegment.Shipment + 'mark-as-received/';

  // Truck Types
  static API_TRUCK_GET_ACTIVE = APIConstants.API_URL_BASE + URLSegment.TruckType + 'active-truck-types';
  static API_GET_ACTIVE_TRUCK_TYPES_CONTRACT_CUSTOMER =
    APIConstants.API_URL_BASE + URLSegment.TruckType + 'active-truck-types-contract-customer';
  static TRUCK_STATUS_CALENDAR = APIConstants.API_URL_BASE + URLSegment.Truck + 'calendar';
  static ADD_ACCIDENT_DETAILS = APIConstants.API_URL_BASE + 'accident-logs/add';
  static GET_ACCIDENT_LOGS = APIConstants.API_URL_BASE + 'accident-logs/logs';

  // Trucks
  static API_GET_ALL_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Truck + 'trucks';
  static API_GET_FLEET_ACTIVE_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Truck + 'active-trucks';
  static API_GET_ALL_BRANDS = APIConstants.API_URL_BASE + URLSegment.Brand + 'brands';
  static API_ADD_TRUCK = APIConstants.API_URL_BASE + URLSegment.Truck + 'add';
  static CREATE_TRUCK_AREA_PREFERENCE = APIConstants.API_URL_BASE + URLSegment.TruckAreaPreference + 'add';
  static UPDATE_TRUCK_AREA_PREFERENCE = APIConstants.API_URL_BASE + URLSegment.TruckAreaPreference + 'update';
  static DELETE_TRUCK_AREA_PREFERENCE = APIConstants.API_URL_BASE + URLSegment.TruckAreaPreference + 'delete/';

  static API_GET_TRUCK_BY_ID = APIConstants.API_URL_BASE + URLSegment.Truck;
  static API_UPDATE_TRUCK = APIConstants.API_URL_BASE + URLSegment.Truck + 'update';
  static API_INTEGRATE_FLEET_WITH_3LEM = APIConstants.API_URL_BASE + URLSegment.Elm + URLSegment.Vehicle;
  static API_ADD_BULK_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Truck + 'add-bulk-trucks';
  static API_CHECK_BULK_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Truck + 'check-bulk-trucks';
  static GET_TRUCK_BY_AVL_ID = APIConstants.API_URL_BASE + URLSegment.Truck;
  static TRUCK_OPERATION_STATUS = APIConstants.API_URL_BASE + URLSegment.Truck + 'operation-status';
  static OPERATION_STATUS_EXPORT = APIConstants.API_URL_BASE + URLSegment.Truck + 'operation-status-export';
  static GET_TRUCK_CUSTOM_REPORT = APIConstants.API_URL_BASE + URLSegment.Traccar + 'custom-report';
  static GET_AVL_GROUPS = APIConstants.API_URL_BASE + URLSegment.Traccar + 'groups';
  static GET_FLEET_TRUCKS_PLANNING = APIConstants.API_URL_BASE + URLSegment.Truck + 'fleet-trucks-planing';
  static GET_TRUCK_LOCATION = APIConstants.API_URL_BASE + URLSegment.Truck + 'truck-location';
  static VERIFY_TRUCK_BY_ELM = APIConstants.API_URL_BASE + URLSegment.Truck + 'verify-truck-by-elm';
  static GET_TRUCK_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.Truck + 'truck-shipment/';
  static RELEASE_TRUCK = APIConstants.API_URL_BASE + URLSegment.Truck + 'release';
  static GET_TRUCK_TEMPERATURE_LOG_PDF = APIConstants.API_URL_BASE + URLSegment.Traccar + 'export-traccar-report';
  static GET_RENTED_TRUCK_DASHBOARD = APIConstants.API_URL_BASE + URLSegment.Truck + 'rented-trucks-dashboard';
  static GET_TRUCKS_COUNT_BY_STATUS = APIConstants.API_URL_BASE + URLSegment.Truck + 'trucks-counts-by-status';

  // Drivers
  static API_GET_ACTIVE_DRIVERS = APIConstants.API_URL_BASE + URLSegment.Driver + 'active-drivers';
  static API_ADD_DRIVER = APIConstants.API_URL_BASE + URLSegment.Driver + 'add';
  static API_GET_ALL_DRIVERS = APIConstants.API_URL_BASE + URLSegment.Driver + 'drivers';
  static API_GET_DRIVER_BY_ID = APIConstants.API_URL_BASE + URLSegment.Driver;
  static API_UPDATE_DRIVER = APIConstants.API_URL_BASE + URLSegment.Driver + 'update';
  static API_INTEGRATE_WITH_3LEM = APIConstants.API_URL_BASE + URLSegment.Elm + URLSegment.Driver;
  static API_SEND_PASSWORD = APIConstants.API_URL_BASE + URLSegment.Driver + 'send-password';
  static API_GET_DRIVER_LOCATION =
    environment.socket_url + environment.api_version + environment.api_prefix + URLSegment.DriverLocation + 'all';
  static API_GET_DRIVER_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.Driver + 'driver-shipments/';
  static API_DRIVER_MOVE_TO_FLEET = APIConstants.API_URL_BASE + URLSegment.Driver + 'transfer-to-fleet';
  static API_GET_EXPORT_DRIVERS = APIConstants.API_URL_BASE + URLSegment.Driver + 'export-drivers-excel';
  static API_GET_ORGANIZATION_DRIVERS_LOCATION =
    environment.socket_url + environment.api_version + environment.api_prefix + URLSegment.DriverLocation + 'organization-drivers';
  static API_GET_CUSTOMER_DRIVERS_LOCATION =
    environment.socket_url + environment.api_version + environment.api_prefix + URLSegment.DriverLocation + 'customer-drivers';
  static API_GET_FLEET_DRIVERS_LOCATION =
    environment.socket_url + environment.api_version + environment.api_prefix + URLSegment.DriverLocation + 'fleet-drivers';
  static API_ADD_BULK_DRIVERS = APIConstants.API_URL_BASE + URLSegment.Driver + 'add-bulk-drivers';
  static API_CHECK_BULK_DRIVERS = APIConstants.API_URL_BASE + URLSegment.Driver + 'check-bulk-drivers';

  static API_ADD_BULK_DRIVERS_WITH_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Driver + 'add-bulk-trucks-with-drivers';
  static API_CHECK_BULK_DRIVERS_WITH_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Driver + 'check-bulk-trucks-with-drivers';
  static VERIFY_DRIVER_BY_ELM = APIConstants.API_URL_BASE + URLSegment.Driver + 'verify-driver-by-elm';
  static RELEASE_DRIVER = APIConstants.API_URL_BASE + URLSegment.Driver + 'release';

  // Trailer
  static ADD_TRAILER = APIConstants.API_URL_BASE + URLSegment.Trailer + 'add';
  static UPDATE_TRAILER = APIConstants.API_URL_BASE + URLSegment.Trailer + 'update';
  static GET_ALL_FLEET_TRAILERS = APIConstants.API_URL_BASE + URLSegment.Trailer + 'fleet-trailers';
  static GET_TRILER_BY_ID = APIConstants.API_URL_BASE + URLSegment.Trailer;

  // Contract
  static API_GET_ALL_CONTRACTS = APIConstants.API_URL_BASE + URLSegment.Contract + 'contracts';
  static API_GET_RELATED_CONTRACT = APIConstants.API_URL_BASE + URLSegment.Contract + 'related-contract';
  static API_GET_CONTRACT = APIConstants.API_URL_BASE + URLSegment.Contract;
  static API_GET_MATCHED_FLEETS = APIConstants.API_URL_BASE + URLSegment.Contract + 'matched';
  static API_ADD_CONTRACT = APIConstants.API_URL_BASE + URLSegment.Contract + 'add';
  static API_UPDATE_CONTRACT = APIConstants.API_URL_BASE + URLSegment.Contract + 'update';
  static API_GET_GLOBAL_CONTRACT = APIConstants.API_URL_BASE + URLSegment.Contract + 'global-contract';
  static API_ADD_TRADE_LANE = APIConstants.API_URL_BASE + URLSegment.Contract + 'trade-lane/add';
  static API_UPDATE_TRADE_LANE = APIConstants.API_URL_BASE + URLSegment.Contract + 'trade-lane/update';
  static API_UPDATE_CUSTOMER_SHOW_TRUCK_TYPES = APIConstants.API_URL_BASE + URLSegment.Customer + 'update-customer-show-truck-types';
  static GET_TRADE_LANE_PRICES = APIConstants.API_URL_BASE + URLSegment.Contract + 'trade-lane/prices';

  // City
  static API_GET_ACTIVE_CITIES = APIConstants.API_URL_BASE + URLSegment.City + 'active-cities';

  // Lead
  static API_GET_ALL_LEADS = APIConstants.API_URL_BASE + URLSegment.Lead + 'leads';
  static API_DELETE_LEAD = APIConstants.API_URL_BASE + URLSegment.Lead;
  static API_ADD_LEAD_LOCATION = APIConstants.API_URL_BASE + URLSegment.Lead + 'add-b2c-location';

  //dashboard
  static API_GET_ORDER_STATUS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'order-status';
  static API_GET_SHIPMENT_STATUS_COUNTS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'shipment-status-counts';
  static API_GET_ORDER_FULFILLMENT_PER_YEAR = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'order-fulfillment-per-year';
  static API_GET_BUSINESS_UNIT_STATUS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'business-unit-status';
  static API_GET_BUSINESS_UNIT_STATUS_ORGANIZATION = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'business-unit-status-organization';
  static API_GET_TRUCKS_STATUS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'trucks-status';
  static API_GET_TOTAL_DRIVERS_COUNTS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'drivers-counts';
  static API_GET_TOTAL_TRUCKS_COUNTS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'trucks-counts';
  static API_GET_DRIVERS_EXPIRATION_COUNT = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'driver-status';
  static API_GET_TRUCKS_EXPIRATION_COUNT = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'trucks-status-count';
  static API_GET_SHIPMENT_VOLUME = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'shipment-volume';
  static API_GET_MONTHLY_SPENDING = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'spending';
  static API_GET_TOP_ROUTES = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'top-routes';
  static API_GET_ACTIVE_SHIPMENTS = APIConstants.API_URL_BASE + URLSegment.Dashboard + 'active-shipments';

  //invoice
  static API_GET_INVOICES = APIConstants.API_URL_BASE + URLSegment.Invoice + 'invoices';
  static API_REJECT_INVOICE = APIConstants.API_URL_BASE + URLSegment.Invoice + 'reject';
  static DASHBOARD_STATUS_COUNT = APIConstants.API_URL_BASE + URLSegment.Invoice + 'dashboard';
  static API_MARK_PAID = APIConstants.API_URL_BASE + URLSegment.Invoice + 'mark-as-paid';
  static API_EXPORT_ALL_INVOICES = APIConstants.API_URL_BASE + URLSegment.Invoice + 'export-all-invoices';
  static EXPORT_INVOICE_PDF = APIConstants.API_URL_BASE + URLSegment.Invoice + 'export-invoice-pdf';
  static CREATE_INVOICE = APIConstants.API_URL_BASE + URLSegment.Invoice + 'add';
  static GET_FLEET_DELIVERY_NOTES = APIConstants.API_URL_BASE + URLSegment.Shipment + 'fleet-delivery-notes';
  static API_GET_INVOICES_COUNTS = APIConstants.API_URL_BASE + URLSegment.Invoice + 'counts';
  static API_GET_INVOICES_ACTIVITY_STATUS = APIConstants.API_URL_BASE + 'invoice-history/';
  static API_GET_INVOICE_DELIVERY_NOTES = APIConstants.API_URL_BASE + URLSegment.Shipment + 'invoice-delivery-notes';
  static API_GET_EXPORT_DELIVERY_NOTE = APIConstants.API_URL_BASE + URLSegment.Shipment + 'invoice-delivery-notes-export';
  static PAID_PARTIALLY_PAYMENT = APIConstants.API_URL_BASE + URLSegment.PartialInvoice + 'mark-as-paid';
  static UPDATE_INVOICE = APIConstants.API_URL_BASE + URLSegment.Invoice + 'update';
  static GET_INVOICES_BY_STATUS = APIConstants.API_URL_BASE + URLSegment.Invoice + 'get-customer-invoices-by-status';

  //Route Time
  static API_ADD_ROUTE_TIME = APIConstants.API_URL_BASE + URLSegment.RouteTime + 'add';
  static API_GET_ROUTE_TIMES = APIConstants.API_URL_BASE + URLSegment.RouteTime + 'route-times';
  static API_DELETE_TRUCK_TYPE_ROUTE_TIME = APIConstants.API_URL_BASE + URLSegment.RouteTime;
  static API_UPDATE_ROUTE_TIME = APIConstants.API_URL_BASE + URLSegment.RouteTime + 'update';

  //reports
  static API_GET_TRUCKS_REPORT = APIConstants.API_URL_BASE + URLSegment.Truck + 'trucks-summary';
  static API_GET_TRUCKS_REPORT_CSV = APIConstants.API_URL_BASE + URLSegment.Truck + 'trucks-summary-csv';
  static INTEGRATION_REPORT = APIConstants.API_URL_BASE + URLSegment.Integration + 'integration-actions-report';
  static SHIPMENT_GATES_REPORT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'shipment-gates-report';
  static TRUCK_UTILIZATION_REPORT = APIConstants.API_URL_BASE + URLSegment.Truck + 'truck-report-utilization';

  static API_GET_SPECIFIC_FLEET_WITHOUT_CONTRACT = APIConstants.API_URL_BASE + URLSegment.Fleet + 'specific-fleets-without-contracts';

  static EXPORT_TRANSPORTATION_PAYMENT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'export-transportation-payment';
  static GET_INVOICES_TRANSPORTATION = APIConstants.API_URL_BASE + URLSegment.InvoiceTransportation + 'invoices-transportation';
  static GET_TRANSPORTATION_PAYMENTS = APIConstants.API_URL_BASE + URLSegment.Shipment + 'transportation-payment';

  static GET_ALL_MEASUREMENT_UNITS = APIConstants.API_URL_BASE + URLSegment.MeasurementUnit + 'measurement-units';

  // permit
  static API_GET_PERMIT_ACCESS = APIConstants.API_URL_BASE + URLSegment.PermitAccess + 'receivers';
  static UPDATE_DRIVER_PERMIT = APIConstants.API_URL_BASE + URLSegment.PermitAccess;
  static UPDATE_TRUCK_PERMIT = APIConstants.API_URL_BASE + URLSegment.PermitAccess + 'trucks/';

  //avl
  static GET_AVL_DEVICES = APIConstants.API_URL_BASE + URLSegment.Traccar + 'devices';
  static GET_AVL_MOBILE_DEVICES = APIConstants.API_URL_BASE + URLSegment.Traccar + 'mobile-devices';
  static GET_AVL_POSITIONS = APIConstants.API_URL_BASE + URLSegment.Traccar + 'positions';
  static GET_AVL_MOBILE_POSITIONS = APIConstants.API_URL_BASE + URLSegment.Traccar + 'mobile-positions';
  static GET_AVL_SHIPMENT_STOPS = APIConstants.API_URL_BASE + URLSegment.Traccar + 'shipment-stops';
  static GET_SHIPMENT_AVL_SUMMARY = APIConstants.API_URL_BASE + URLSegment.Traccar + 'summary/';
  static GET_AVL_EXTERNAL_DEVICES = APIConstants.API_URL_BASE + URLSegment.ExternalTracking + 'devices/' + 'AFAQY';

  static GET_LOOKUPS = APIConstants.API_URL_BASE + URLSegment.Shared + 'lookups/';
  static GET_GLOBAL_SEARCH_LOOKUPS = APIConstants.API_URL_BASE + URLSegment.Shared + 'search-any-where/';

  // Customer Support
  static ADD_TICKET = APIConstants.API_URL_BASE + URLSegment.CustomerSupport + URLSegment.Ticket + 'add';
  static GET_SUPPORT_TOKEN = APIConstants.API_URL_BASE + URLSegment.CustomerSupport + 'token';
  static GET_TICKET = APIConstants.API_URL_BASE + URLSegment.CustomerSupport + 'ticket';

  // TODO: will be removed after firebase integration
  static notificationToken =
    'faT0L2ESFgYKJHSzSbMVzN:APA91bEwqkr77LvQpFSBEXIcr5t_BgYg7DNFPhgXkahKDg_I5W7qRueAhDZV8zEr2Zc8SjDhBuIO3N9Rosi8E11GLNHIGdNVueGG';
  static UPLOAD_TICKET_MEDIA = APIConstants.API_URL_BASE + URLSegment.CustomerSupport + 'ticket-upload';

  static WCC_GET_BALANCE = APIConstants.API_URL_BASE + URLSegment.WCC + 'landing-balance';
  static WCC_GET_PRODUCTS = APIConstants.API_URL_BASE + URLSegment.WCC + 'products';
  static WCC_GET_PRODUCT_PRICE = APIConstants.API_URL_BASE + URLSegment.WCC + 'get-product-price';
  static WCC_GET_TIME_SLOTS = APIConstants.API_URL_BASE + URLSegment.WCC + 'get-available-slots';
  static WCC_CREATE_SHIPMENT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'add/beta';

  static WCC_USERS_WITH_PARAMS = APIConstants.API_URL_BASE + URLSegment.Customer + 'users-with-params';
  static WCC_GET_DELIVERY_NOTE_LINE = APIConstants.API_URL_BASE + URLSegment.WCC + 'get-delivery-note-line';
  static WCC_GET_ORDER_LOGS = APIConstants.API_URL_BASE + URLSegment.WCC + 'order-logs';
  static WCC_INTEGRATE_WITH_CEMENT = APIConstants.API_URL_BASE + URLSegment.WCC + 'update-order';

  //Online Booking
  static GET_SPECIFIC_CITIES_ONLINE_BOOKING = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'get-specific-cities-online-booking';
  static ALL_FROM_CITIES = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'all-from-cities';
  static AVAILABLE_TO_CITIES = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'available-to-cities';
  static CHECK_OPPOSITE_TRADE_LANE = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'check-opposite-trade-lane';
  static GET_SPECIFIC_TRUCKS_ONLINE_BOOKING = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'get-specific-trucks-online-booking';
  static GET_PRODUCT_TYPES_ONLINE_BOOKING = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'get-product-types-online-booking';
  static GET_SHIPMENT_PRICE_ONLINE_BOOKING = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'get-shipment-price-online-booking';
  static CONFIRM_BOOKING_SHIPMENT_ONLINE_BOOKING =
    APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'confirm-booking-shipment-online-booking';
  static VERIFY_OTP_ONLINE_BOOKING = APIConstants.API_URL_BASE + URLSegment.OnlineBooking + 'verify-otp-online-booking';

  //Booking
  static API_GET_BOOKING_CITIES = APIConstants.API_URL_BASE + URLSegment.Shared + 'cities';
  static API_GET_BOOKING_PRICES = APIConstants.API_URL_BASE + URLSegment.Shared + 'prices';

  // heat map
  static HEAT_MAP_RECEIVERS = APIConstants.API_URL_BASE + URLSegment.WCC + 'receivers-shipments-counts';
  static HEAT_MAP_RECEIVER_CUSTOMERS = APIConstants.API_URL_BASE + URLSegment.Customer + 'customer-with-shipment-count';
  static HEAD_MAP_ALL_SHIPMENTS_COUNT = APIConstants.API_URL_BASE + URLSegment.Shipment + 'cement-shipments-count';

  // Orders
  static API_GET_ORDER_LIST = APIConstants.API_URL_BASE + URLSegment.Order + 'list';
  static API_GET_ORDERS_COUNT = APIConstants.API_URL_BASE + URLSegment.Order + 'count';
  static API_GET_PALLET_LIST = APIConstants.API_URL_BASE + URLSegment.Pallet + 'pallet-list';
  static API_GET_ORDERS_PALLET_LIST = APIConstants.API_URL_BASE + URLSegment.Pallet + 'orders-pallet-list';
  static API_GET_PLAN_TRUCKS = APIConstants.API_URL_BASE + URLSegment.Truck + 'available-trucks';
  static API_GET_UNDETAILED_ORDER_INFO = APIConstants.API_URL_BASE + URLSegment.Order + 'order-line-items';

  static API_GET_TABLEAU_TOKEN = APIConstants.API_URL_BASE + 'shared/tableau-auth';

  // distribute-fleets
  static API_DISTRIBUTE_FLEETS_ACCEPT_ACTION = APIConstants.API_URL_BASE + URLSegment.DistributeFleets + 'accept-action';
  static API_DISTRIBUTE_FLEETS_DECLINED_ACTION = APIConstants.API_URL_BASE + URLSegment.DistributeFleets + 'declined-action';

  static LOGOUT = APIConstants.API_URL_BASE + URLSegment.Auth + 'logout';

  // Announcement
  static GET_ANNOUNCEMENT = APIConstants.API_URL_BASE + URLSegment.Announcement;
  static SET_ANNOUNCEMENT = APIConstants.API_URL_BASE + URLSegment.Announcement + 'add';

  // Fleet Survey
  static API_ADD_FLEET_SURVEY = APIConstants.API_URL_BASE + URLSegment.FleetSurvey + 'survey';
  static ADD_PRODUCT_TYPE = APIConstants.API_URL_BASE + URLSegment.ProductType + 'add-for-customer';
}
